import { Button } from "@/dentlab/src/components/ui/button";
import { ArrowLeft } from "lucide-react";

export const FileViewerModalHeader: React.FC<{
    fileName: string;
    onClose: () => void;
}> = ({ fileName, onClose }) => (
    <div className="absolute top-0 left-0 right-0 z-10 flex items-center justify-between p-4 bg-gradient-to-b from-black/60 via-black/30 to-transparent">
        <div className="flex items-center gap-3">
            <Button
                variant="ghost"
                size="icon"
                onClick={onClose}
                className="text-white hover:bg-white/20"
                aria-label="Zurück"
            >
                <ArrowLeft className="h-5 w-5" />
            </Button>
            <h1 className="text-white text-lg font-medium drop-shadow-md truncate max-w-md">
                {fileName}
            </h1>
        </div>
    </div>
);
